import { Util } from './_util.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { SplitText } from 'gsap/SplitText';
import Swiper from 'swiper' ;
import { Navigation, Pagination, Scrollbar, Parallax, Autoplay } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Scrollbar, Parallax, Autoplay]);
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, SplitText);

var device = 'mobile',
    prev = 0;

const App = {
  checkTouchDevice: function () {
    if ("ontouchstart" in document.documentElement){
      $('body').addClass('touch-device');
    } else {
      $('body').addClass('no-touch-device');
    }
  },

  animateElements: function () {
    $(window).on('scroll', function(){
      var scrollTop = $(window).scrollTop(),
          windowHeight = $(window).height(),
          documentHeight = $(document).height(),
          bottomOfWindow = $(window).scrollTop() + $(window).height();
      if (documentHeight > windowHeight) {
        if ((scrollTop > 50) && (scrollTop + windowHeight < documentHeight - 150)) {
          $('.header').toggleClass('header--hide', scrollTop > prev);
        } else if (scrollTop + windowHeight >= documentHeight - 150) {
          $('.header').addClass('header--hide');
        } else {
          $('.header').removeClass('header--hide');
        }
      } else {
        $('.header--hide').removeClass('header--hide');
      }

      $('.header').toggleClass('header--scroll', scrollTop > 150);

      prev = scrollTop;

      $('.work-grid__item').each( function(){
        var topOfObject = $(this).offset().top + 100;
        if(bottomOfWindow > topOfObject){
          $(this).addClass('animate');
        }
      });

      $('.work-grid__item.animation').each( function(){
        var topOfObject = $(this).offset().top + 100;
        if(bottomOfWindow > topOfObject){
          $(this).addClass('animate');
        }
      });
    });
  },

  checkDeviceWidth: function () {
    $(window).on("resize", function() {
      $(window).trigger('scroll');
			var windowWidth = $(window).innerWidth();
			if(windowWidth > 980){
				if(device == 'mobile'){
					$('.header').removeClass('header--open');
					$('.main-menu').removeClass('main-menu--open');
          $('.main-menu__toggle-btn--close').removeClass('main-menu__toggle-btn--close');
          $('html').removeClass('hidden');
					device = 'desktop';
				}
			} else {
				if(device == 'desktop'){
					$('.main-menu').removeClass('main-menu--open');
					device = 'mobile';
				}
			}
		}).resize();
  },

  controlAnimation: function () {
    $(window).on("resize", function() {
      $("body").addClass("no-animation");
      setTimeout(function(){
          $(".no-animation").removeClass("no-animation");
      }, 200);
    }).resize();
  },

  getCopyrightYear: function () {
    const currentTime = new Date(),
          currentYear = currentTime.getFullYear();
    $('.footer .year').html(currentYear);
  },

  controlMainMenu: function () {
    function openMainMenu() {
      $('.header').addClass('header--open');
      $('.main-menu').scrollTop(0);
      $('.main-menu__toggle-btn').addClass('main-menu__toggle-btn--close');
      $('html').addClass('hidden');
    }

    function closeMainMenu() {
      $('.header').removeClass('header--open');
      $('.main-menu__toggle-btn').removeClass('main-menu__toggle-btn--close');
      $('html').removeClass('hidden');
    }

    $('.main-menu__toggle-btn').on('click',function(){
      if($(this).hasClass('main-menu__toggle-btn--close')){
        closeMainMenu();
      } else {
        openMainMenu();
      }
    });
	
		$('.touch-device .main-menu__link').on('click',function(e){
			e.preventDefault();
			var newUrl = $(this).attr('href');
			var newUrlTarget = $(this).attr('target');
			$(this).addClass('touch-active');
			setTimeout(function(){
				if(newUrlTarget == "_blank") {
					window.open(newUrl);
				} else {
					window.location = newUrl;
				}
			},300);
		});
  },

  controlMobileClickTrigger: function () {
    $('.touch-device .main-menu__callout-cta, .touch-device .header__logo, .touch-device .footer__logo, .touch-device .footer__callout-cta, .touch-device a.cta, .touch-device .work-grid__item, .touch-device .featured-work-module__item').on('click',function(e){
      e.preventDefault();
      var newUrl = $(this).attr('href');
      var newUrlTarget = $(this).attr('target');
      $(this).addClass('touch-active');
      setTimeout(function(){
        if(newUrlTarget == "_blank") {
          window.open(newUrl);
        } else {
          window.location = newUrl;
        }
      },400);
    });
  },

  controlLinksModule: function () {
    $('.no-touch-device .links-module__cta').on('mouseenter',function(){
      const itemNumber = $(this).parent('.links-module__item').index() + 1;
      $('.links-module__image img:not(:nth-child(' + itemNumber + '))').fadeOut(400);
      $('.links-module__image img:nth-child(' + itemNumber + ')').fadeIn(400);
    });
    if ($("body").hasClass("touch-device")) {
      function crossfadeLoop() {
        const images = $(".links-module__image img");
        let currentIndex = 0;
        function showNextImage() {
          const nextIndex = (currentIndex + 1) % images.length;
          $(images[currentIndex]).fadeOut(500);
          $(images[nextIndex]).fadeIn(500, function () {
            currentIndex = nextIndex;
            setTimeout(showNextImage, 3000);
          });
        }
        images.hide().eq(currentIndex).show();
        showNextImage();
      }
      crossfadeLoop();
    }
  },

  controlWorkHighlightsModule: function () {
    $('.highlights-block__list-item-btn').on('click',function(){
			const highlightNumber = $(this).attr('data-count');
      var windowWidth = $(window).innerWidth();
      if(windowWidth > 760){
        $(this).addClass('highlights-block__list-item-btn--current');
        $('.highlights-block__list-item-btn--current').not(this).removeClass('highlights-block__list-item-btn--current');

        //Desktop
        $('.highlights-block__list-content .highlights-block__list-content-copy').removeClass('animate').hide();
        $('.highlights-block__list-content .highlights-block__list-content-copy[data-count="' + highlightNumber + '"]').show();
        setTimeout(function(){
          $('.highlights-block__list-content .highlights-block__list-content-copy[data-count="' + highlightNumber + '"]').addClass('animate');
        }, 100);

        //Mobile
        $(this).siblings('.highlights-block__list-content-copy').addClass('animate').slideDown(500, 'swing');
        $('.highlights-block__list-item-btn').not(this).siblings('.highlights-block__list-content-copy').removeClass('animate').slideUp(500, 'swing');
      } else {
        if($(this).hasClass('highlights-block__list-item-btn--current')){
          $(this).removeClass('highlights-block__list-item-btn--current');

          //Desktop
          $('.highlights-block__list-content .highlights-block__list-content-copy').removeClass('animate').hide();
          $('.highlights-block__list-content .highlights-block__list-content-copy[data-count="' + highlightNumber + '"]').show();
          setTimeout(function(){
            $('.highlights-block__list-content .highlights-block__list-content-copy[data-count="' + highlightNumber + '"]').addClass('animate');
          }, 100);

          //Mobile
          $(this).siblings('.highlights-block__list-content-copy').removeClass('animate').slideUp(500, 'swing');
        } else {
          $(this).addClass('highlights-block__list-item-btn--current');

          //Desktop
          $('.highlights-block__list-content .highlights-block__list-content-copy').removeClass('animate').hide();
          $('.highlights-block__list-content .highlights-block__list-content-copy[data-count="' + highlightNumber + '"]').show();
          setTimeout(function(){
            $('.highlights-block__list-content .highlights-block__list-content-copy[data-count="' + highlightNumber + '"]').addClass('animate');
          }, 100);

          //Mobile
          $(this).siblings('.highlights-block__list-content-copy').addClass('animate').slideDown(500, 'swing');
        }
      }
    });
  },

  controlAnchors: function () {
    var anchoredSection,
        windowWidth = $(window).innerWidth(),
        offsetHeight;

    if(windowWidth > 980){
      offsetHeight = '150';
    } else {
      offsetHeight = '100';
    }

		if (sessionStorage && sessionStorage.getItem("session")) {
      anchoredSection = sessionStorage.getItem("session");
      const $anchoredElement = $(anchoredSection);
      if ($anchoredElement.length) {
        setTimeout(function(){
          $('html, body').animate({
              scrollTop: $anchoredElement.offset().top - offsetHeight
          }, 850, 'swing');
          sessionStorage.clear();
        },300);
      }
		}

    $('.links-module__cta').on('click', function(e) {
      e.preventDefault();
      const anchoredSection = this.hash,
            $anchoredSection = $(anchoredSection),
            href = $(this).attr('href'),
            linkUrl = new URL(href, window.location.origin),
            isSamePage = linkUrl.hostname === window.location.hostname && linkUrl.pathname === window.location.pathname;

      if (isSamePage) {
        $('html, body').animate({
          scrollTop: $anchoredSection.offset().top - offsetHeight
        }, 850, 'swing');
      } else {
        sessionStorage.setItem("session", anchoredSection);
        window.location.href = linkUrl.pathname;
      }
    });
  },

  controlHighlights: function () {
    const $listItems = $('.highlights-module__row');
    const $imageItems = $('.highlights-module__grid > .highlights-module__image > img');
    let listindex = 1,
        imageindex = 1,
        highlightsInterval;

    highlightsInterval = setInterval(function() {
      $listItems.find('h2').removeClass('current');
      $listItems.find('.highlights-module__description').slideUp({
        queue: false,
        duration: 500,
        easing: 'swing'
      }).animate({ opacity: 0 }, {
        queue: false,
        duration: 500,
        easing: 'swing'
      });

      $listItems.eq(listindex).find('h2').addClass('current');
      $listItems.eq(listindex).find('.highlights-module__description').slideDown({
        queue: false,
        duration: 500,
        easing: 'swing'
      }).animate({ opacity: 1 }, {
        queue: false,
        duration: 500,
        easing: 'swing'
      }).css('display','flex');

      $imageItems.eq(imageindex).animate({ opacity: 0 }, {
        queue: false,
        duration: 500,
        easing: 'swing'
      });

      $imageItems.eq(imageindex).animate({ opacity: 1 }, {
        queue: false,
        duration: 500,
        easing: 'swing'
      });

      listindex = (listindex + 1) % $listItems.length;
      imageindex = (imageindex + 1) % $imageItems.length;
    }, 5000);


    $(window).on('scroll', function(){
      var bottomOfWindow = $(window).scrollTop() + $(window).height();

      $('.section--accordion').each( function(){
        var topOfObject = $(this).offset().top;
        if(bottomOfWindow > topOfObject){
          clearInterval(highlightsInterval);
        }
      });
    });

    $('.highlights-module__row h2').on('click',function(){
      var itemIndex = $(this).parent().index() + 1;
      if(!$(this).hasClass('current')) {
        $(this).addClass('current');
        $(this).siblings('.highlights-module__description').slideDown({
          duration: 500,
          easing: 'swing'
        }).animate({ opacity: 1 }, {
          queue: false,
          duration: 500,
          easing: 'swing'
        }).css('display','flex');
        $('.highlights-module__image img:nth-child(' + itemIndex +')').animate({ opacity: 1 }, {
          queue: false,
          duration: 500,
          easing: 'swing'
        });
        $('.highlights-module__row h2').not(this).removeClass('current');
        $('.highlights-module__row h2').not(this).siblings('.highlights-module__description').slideUp({
          duration: 500,
          easing: 'swing'
        }).animate({ opacity: 0 }, {
          queue: false,
          duration: 500,
          easing: 'swing'
        });
        $('.highlights-module__image img:not(:nth-child(' + itemIndex +'))').animate({ opacity: 0 }, {
          queue: false,
          duration: 500,
          easing: 'swing'
        });
      }
      clearInterval(highlightsInterval);
    });
  },

  controlAccordionModule: function () {
    var itemOffset;

    $('.accordion-module__item-btn').on('click',function(){
      if($(this).hasClass('accordion-module__item-btn--current')) {
        $(this).removeClass('accordion-module__item-btn--current');
        $(this).siblings('.accordion-module__item-copy').removeClass('animate').slideUp(500, 'swing');
      } else {
        if($(this).parent('accordion-module__item').is(':first-child')) {
          itemOffset = 100;
        } else {
          itemOffset = 150;
        }
        var anchoredSection = $(this).parent('.accordion-module__item');
        $(this).addClass('accordion-module__item-btn--current');
        $(this).siblings('.accordion-module__item-copy').addClass('animate').slideDown(500, 'swing');
        $('.accordion-module__item-btn').not(this).removeClass('accordion-module__item-btn--current');
        $('.accordion-module__item-btn').not(this).siblings('.accordion-module__item-copy').addClass('animate').slideUp(500, 'swing', function() {
          $('html, body').animate({
            scrollTop: anchoredSection.offset().top - itemOffset
          }, 500, 'swing');
        });
      }
    });
  },

  controlMobileHover: function () {
    $(".touch-device .hero-module .swiper-button, .touch-device .testimonials-module .swiper-button").on("click", function () {
      const $this = $(this);
      $this.addClass("hovered");
      setTimeout(function () {
          $this.removeClass("hovered");
      }, 600);
    });
  },

  filterWork: function () {
    $('.work-grid__filter-toggle').on('click',function(e){
      e.preventDefault();
      if($('.work-grid__filter-menu').hasClass('work-grid__filter-menu--open')) {
        $('.work-grid__filter-menu').removeClass('work-grid__filter-menu--open');
      } else {
        $('.work-grid__filter-menu').addClass('work-grid__filter-menu--open');
      }
    });
    $('.work-grid__filter-btn').on('click',function(e){
      e.preventDefault();
      var filter = $(this).attr('data-id');
      if($(this).hasClass('work-grid__filter-btn--current')) {
        $(this).removeClass('work-grid__filter-btn--current');
        $('.work-grid__item').removeClass('animate').hide();
        $('.work-grid__item').addClass('animation').show();
        setTimeout(function(){
          $(window).trigger('scroll');
        }, 100);
      } else {
        $('.work-grid__filter-btn--current').removeClass('work-grid__filter-btn--current');
        $(this).addClass('work-grid__filter-btn--current');
        $('.work-grid__item').removeClass('animate').hide();
        $('.work-grid__item.' + filter).addClass('animation').show();
        setTimeout(function(){
          $(window).trigger('scroll');
        }, 100);
      }
      setTimeout(function(){
        $('.work-grid__filter-menu').removeClass('work-grid__filter-menu--open');
      }, 600);
    });
  },

  initSwipers: function () {
    $('.hero-module__swiper-container').each(function (index) {
      const navigationVar = 's'+index;
      $(this).siblings('.swiper-button').addClass(navigationVar);
      const swiper = new Swiper($(this)[0], {
        effect: 'slide',
        slidesPerView: 'auto',
        parallax: true,
        speed: 600,
        loop: true,
        grabCursor: true,
        autoplay: {
          disableOnInteraction: true,
        },
        simulateTouch: true,
        navigation: {
          nextEl: '.swiper-button--next.' + navigationVar,
          prevEl: '.swiper-button--previous.' + navigationVar,
        },
      });
    });

    $('.testimonials-module__swiper-container').each(function (index) {
      const navigationVar = 's'+index;
      $(this).siblings('.swiper-button').addClass(navigationVar);
      const swiper = new Swiper($(this)[0], {
        effect: 'slide',
        slidesPerView: 'auto',
        parallax: true,
        speed: 900,
        loop: true,
        grabCursor: true,
        autoplay: {
          disableOnInteraction: true,
        },
        simulateTouch: true,
        navigation: {
          nextEl: '.swiper-button--next.' + navigationVar,
          prevEl: '.swiper-button--previous.' + navigationVar,
        },
      });
    });
  },

  initPeopleModal: function () {
    $('.no-touch-device .people-grid-module__item').on('click', function (e) {
      e.preventDefault();
      const item_name = $(this).attr('data-name'),
        item_position = $(this).attr('data-position'),
        item_bio = $(this).attr('data-bio'),
        item_image_url = $(this).attr('data-image-url');
      $('.people-modal-module__image').css('background-image', 'url("' + item_image_url + '")');
      $('.people-modal-module__name').html(item_name);
      $('.people-modal-module__bio').html(item_bio);
      $('html').addClass('hidden');
      $('.people-modal-module').addClass('people-modal-module--open');
    });

		$('.touch-device .people-grid-module__item').on('click',function(e){
			e.preventDefault();
      const item_name = $(this).attr('data-name'),
        item_position = $(this).attr('data-position'),
        item_bio = $(this).attr('data-bio'),
        item_image_url = $(this).attr('data-image-url');
			$(this).addClass('touch-active');
      $('.people-modal-module__image').css('background-image', 'url("' + item_image_url + '")');
      $('.people-modal-module__name').html(item_name);
      $('.people-modal-module__bio').html(item_bio);
			setTimeout(function(){
        $('html').addClass('hidden');
        $('.people-modal-module').addClass('people-modal-module--open');
			},300);
			setTimeout(function(){
        $('.people-grid-module__item.touch-active').removeClass('touch-active');
			},600);
		});

    $('.people-modal-module__overlay, .no-touch-device .people-modal-module__close-btn').on('click', function () {
      $('html').removeClass('hidden');
      $('.people-modal-module--open').removeClass('people-modal-module--open');
      setTimeout(function () {
        $('.people-modal-module__row, .people-modal-module__col').scrollTop(0);
      }, 600);
    });

    $('.touch-device .people-modal-module__close-btn').on('click', function () {
      const $this = $(this);
      $this.addClass("hovered");
      setTimeout(function () {
        $('html').removeClass('hidden');
        $('.people-modal-module--open').removeClass('people-modal-module--open');
      }, 600);
      setTimeout(function () {
        $('.people-modal-module__row, .people-modal-module__col').scrollTop(0);
        $('.people-modal-module__close-btn').removeClass("hovered");
      }, 1200);
    });
  },

  initGSAP: function () {
    const accordionModuleItem = gsap.utils.toArray('.accordion-module__item'),
          bannerModule = gsap.utils.toArray('.banner-module'),
          calloutModuleHeadline = gsap.utils.toArray('.callout-module__headline'),
          contactModule = gsap.utils.toArray('.contact-module__row:first-child'),
          expertiseModuleImage = gsap.utils.toArray('.expertise-module__image'),
          introModuleBlock = gsap.utils.toArray('.intro-block'),
          featuredModuleItem = gsap.utils.toArray('.featured-work-module__item'),
          footerCalloutCTA = gsap.utils.toArray('.footer__callout-cta'),
          heroModuleHeadline = gsap.utils.toArray('.hero-module__headline'),
          heroModuleSwiper = gsap.utils.toArray('.hero-module__swiper-container'),
          highlightsModuleHeadline = gsap.utils.toArray('.highlights-module__headline'),
          highlightsModuleBlock = gsap.utils.toArray('.highlights-block'),
          historyModuleItem = gsap.utils.toArray('.history-module__item'),
          imagesModuleBlockImage = gsap.utils.toArray('.images-block__image'),
          linksModule = gsap.utils.toArray('.links-module__wrapper--default'),
          linksModuleItem = gsap.utils.toArray('.links-module__item--with-images'),
          overviewModuleImage = gsap.utils.toArray('.overview-block__image'),
          peopleModuleItem = gsap.utils.toArray('.people-grid-module__item'),
          testimonialsModuleHeadline = gsap.utils.toArray('.testimonials-module__headline');

    let matchMedia = gsap.matchMedia();

    matchMedia.add(
      {
        isDesktop: '(min-width: 981px)',
        isTablet: '(max-width: 980px) and (min-width: 761px)',
        isMobile: '(max-width: 760px)',
      },
      (context) => {
        let { isDesktop, isTablet, isMobile } = context.conditions;

        accordionModuleItem.forEach((section) => {
          gsap.to(section, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "power2.out",
            startAt: {
              y: 80,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        bannerModule.forEach((section) => {
          gsap.to(section, {
            duration: 1,
            delay: 0.15,
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            ease: "power2.out",
            startAt: {
              clipPath: 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)',
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        calloutModuleHeadline.forEach((section) => {
          const splitText = new SplitText(calloutModuleHeadline, { type: "words" });
          gsap.to(splitText.words, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            stagger: 0.05,
            ease: "power2.out",
            startAt: {
              y: 35,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        contactModule.forEach((section) => {
          gsap.to(section, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "power2.out",
            startAt: {
              y: 80,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        expertiseModuleImage.forEach((section) => {
          gsap.to(section, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "power2.out",
            startAt: {
              y: 80,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        featuredModuleItem.forEach((section) => {
          gsap.to(section, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "power2.out",
            startAt: {
              y: 80,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        footerCalloutCTA.forEach((section) => {
          gsap.to(section, {
            scrollTrigger: {
              trigger: section,
              start: "top 90%",
              toggleActions: "play none none none",
              onEnter: () => {
                section.classList.add("touch-active");
                setTimeout(() => {
                  section.classList.remove("touch-active");
                }, 1000);
              },
            },
          });
        });

        heroModuleSwiper.forEach((section) => {
          gsap.to(section, {
            duration: 1,
            delay: 0.25,
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            ease: "power2.out",
            startAt: {
              clipPath: 'polygon(0 0, 100% 0, 100% 0, 0 0)',
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        heroModuleHeadline.forEach((section) => {
          const splitText = new SplitText(heroModuleHeadline, { type: "words" });
          gsap.to(splitText.words, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            stagger: 0.05,
            ease: "power2.out",
            startAt: {
              y: 35,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        highlightsModuleHeadline.forEach((section) => {
          const splitText = new SplitText(highlightsModuleHeadline, { type: "words" });
          gsap.to(splitText.words, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            stagger: 0.05,
            ease: "power2.out",
            startAt: {
              y: 35,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        historyModuleItem.forEach((section) => {
          gsap.to(section, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "power2.out",
            startAt: {
              y: 50,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        highlightsModuleBlock.forEach((section) => {
          gsap.to(section, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "power2.out",
            startAt: {
              y: 80,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        imagesModuleBlockImage.forEach((section) => {
          gsap.to(section, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "power2.out",
            startAt: {
              y: 80,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        introModuleBlock.forEach((section) => {
          gsap.to(section, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "power2.out",
            startAt: {
              y: 80,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        linksModule.forEach((section) => {
          gsap.to(section, {
            duration: 1,
            delay: 0.15,
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            ease: "power2.out",
            startAt: {
              clipPath: 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)',
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        linksModuleItem.forEach((section) => {
          gsap.to(section, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "power2.out",
            startAt: {
              y: 80,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        overviewModuleImage.forEach((section) => {
          gsap.to(section, {
            duration: 1,
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            ease: "power2.out",
            startAt: {
              clipPath: 'polygon(0 0, 100% 0, 100% 0, 0 0)',
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        peopleModuleItem.forEach((section) => {
          gsap.to(section, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "power2.out",
            startAt: {
              y: 80,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });

        testimonialsModuleHeadline.forEach((section) => {
          const splitText = new SplitText(testimonialsModuleHeadline, { type: "words" });
          gsap.to(splitText.words, {
            y: 0,
            opacity: 1,
            duration: 0.75,
            stagger: 0.05,
            ease: "power2.out",
            startAt: {
              y: 35,
              opacity: 0,
            },
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
        });
      }
    );
  },

  init: function () {
    this.checkTouchDevice();
    this.animateElements();
    this.controlAnimation();
    this.checkDeviceWidth();
    this.controlMainMenu();
    this.controlMobileClickTrigger();
    this.controlLinksModule();
    this.controlWorkHighlightsModule();
    this.controlAnchors();
    this.controlHighlights();
    this.controlAccordionModule();
    this.controlMobileHover();
    this.filterWork();
    this.initSwipers();
    this.initPeopleModal();
    this.getCopyrightYear();
    this.initGSAP();
  },
};

export default App;
